import { useState } from 'react';
import { Box, Grid, TextField, Button, InputAdornment, IconButton, FormControl } from "@mui/material"
import {
  Body,
} from "../../screens/Login/Login.styles"
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function StandardAuth({username, password, handleChange, errorsUsername, errorsPwd, handleForgotPwdClick, isStandardAuth, loginMutation}) {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleTogglePassword = () => setShowPassword((show) => !show);

    return(
        <Box  sx={{width: '100%', margin: '0 auto', minHeight: `calc(100vh - 320px)`}}>
            <Body sx={{fontSize: '20px', fontWeight: 800, color: "#111", lineHeight: '24px'}}>Login to your account</Body>
            <Grid sx={{ marginBottom: '20px',}}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
              >
                <TextField
                    label={"Email"}
                    value={username}
                    placeholder="Enter email"
                    name="username"
                    onChange={handleChange}
                    fullWidth
                    required
                    error={!!errorsUsername}
                    InputLabelProps={{ shrink: true }}
                    helperText={errorsUsername}
                    InputProps={{
                      sx: {
                        backgroundColor: 'white',
                        fontSize: '14px',
                      }
                    }}
                />
              </FormControl>
            </Grid>
            <Grid sx={{ marginBottom: '20px' }}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
              >
                <TextField
                    type={showPassword ? "text" : "password"}
                    label={"Password"}
                    value={password}
                    name="password"
                    placeholder="Enter password"
                    onChange={handleChange}
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                    error={!!errorsPwd}
                    helperText={errorsPwd}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                      sx: {
                        backgroundColor: 'white',
                        fontSize: '14px',
                      }
                    }}
                />
              </FormControl>
            </Grid>
            <Grid sx={{ marginBottom: '20px', }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                    width: '100%'
                }}
                disabled={loginMutation.isPending}
              >
                {loginMutation.isPending ? "Logging in..." : "Log in"}
              </Button>
              </Grid>

              {
                isStandardAuth && <Grid sx={{ marginBottom: '20px', }}>
                  <Button
                    sx={{ width: '100%', textTransform: 'none', color: 'var(--brand-default-color)', textDecoration: 'underline', fontSize: 15, fontWeight: 400 }}
                    variant="outlined"
                    color="secondary"
                    onClick={handleForgotPwdClick}
                  >
                    Forgot password?
                  </Button>
                </Grid>
              } 
            </Box>
    );
}